import { system } from 'styled-system';
import { getPxAbsolute } from '../internal';

const borderBottomLeftRadius = system({
  radiusBL: {
    property: 'borderBottomLeftRadius',
    scale: 'radii',
    transform: getPxAbsolute,
  },
});

export default borderBottomLeftRadius;
